angular.module('gym.grading').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.grading.styles', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.grading.styles.list', {
    url: '/styles',
    template: require('templates/gyms/grading/styles/index.html.slim')
  }).state('gym.grading.styles.new', {
    url: '/styles/new',
    template: require('templates/gyms/grading/styles/edit.html.slim')
  }).state('gym.grading.styles.edit', {
    url: '/styles/:styleId/edit',
    template: require('templates/gyms/grading/styles/edit.html.slim')
  }).state('gym.grading.styles.activeMembers', {
    url: '/styles/:styleId/active_members?rankId',
    template: require('templates/gyms/grading/styles/members.html.slim')
  }).state('gym.grading.styles.cancelledMembers', {
    url: '/styles/:styleId/cancelled_members?rankId',
    template: require('templates/gyms/grading/styles/members.html.slim')
  });
}]);
